import React from "react"
import type { VariableGroups, VariableHint } from "./types"

interface VariableBrowserProps {
  groups?: VariableGroups
  onInsert: (hint: VariableHint) => void
}

const GROUP_LABELS: Array<[keyof VariableGroups, string]> = [
  ["request", "Request"],
  ["provider", "Provider"],
  ["email", "Email"],
  ["steps", "Earlier steps"],
  ["secrets", "Secrets"],
]

export function VariableBrowser({ groups, onInsert }: VariableBrowserProps) {
  const available = GROUP_LABELS.some(([key]) => (groups?.[key] || []).length > 0)
  if (!available) return null

  return (
    <details className="rounded-md border border-indigo-100 bg-indigo-50/50 p-2">
      <summary className="cursor-pointer text-xs font-medium text-indigo-700">
        Browse variables
      </summary>
      <div className="mt-2 grid gap-2 sm:grid-cols-2">
        {GROUP_LABELS.map(([key, label]) => {
          const hints = groups?.[key] || []
          if (hints.length === 0) return null

          return (
            <div key={key}>
              <h5 className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                {label}
              </h5>
              <div className="mt-1 flex flex-wrap gap-1">
                {hints.map((hint) => (
                  <button
                    key={`${key}-${hint.path}`}
                    type="button"
                    className="rounded border border-indigo-200 bg-white px-1.5 py-0.5 font-mono text-[11px] text-indigo-700 hover:bg-indigo-100"
                    title={`Insert ${hint.template || hint.path}`}
                    onClick={() => onInsert(hint)}
                  >
                    {hint.label || hint.path}
                  </button>
                ))}
              </div>
            </div>
          )
        })}
      </div>
      <p className="mt-2 text-[11px] text-gray-500">
        Values are resolved from the bounded event context. Secret values are never shown.
      </p>
    </details>
  )
}
